import { FileUp, ImagePlus, UserIcon, Video } from 'lucide-react';
import { useState } from 'react';

import CreatePost from '@/components/features/manage/manage-posts/CreatePost';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useCredentials } from '@/store/auth-store';

export default function HomeCreatePost() {
  const [openPostAdd, setOpenPostAdd] = useState<boolean>(false);

  const creadentials = useCredentials();

  const handleOpenChange = (nextOpen: boolean) => {
    setOpenPostAdd(nextOpen);
  };

  const openDialogWithTitleFocus = () => {
    if (openPostAdd) {
      return;
    }
    setOpenPostAdd(true);
  };

  return (
    <>
      <CreatePost open={openPostAdd} onOpenChange={handleOpenChange} />
      <div className={'bg-background flex w-full flex-col gap-3 rounded-2xl border p-4 md:flex-row'}>
        <div className="flex grow gap-3">
          <Avatar size={'md'} className="border-border-primary border">
            <AvatarImage src={creadentials.avatarURL ?? undefined} alt={`${creadentials.name} ${creadentials.surname}`} />
            <AvatarFallback>
              <UserIcon className="size-3.5" />
            </AvatarFallback>
          </Avatar>
          <Input placeholder="Napisz wiadomość..." className="w-full" onClick={openDialogWithTitleFocus} onFocus={openDialogWithTitleFocus} />
        </div>
        <div className={'flex flex-row justify-end gap-2'}>
          <Button
            type={'button'}
            variant={'outline'}
            onClick={() => {
              handleOpenChange(true);
            }}
          >
            <ImagePlus />
          </Button>
          <Button
            type={'button'}
            variant={'outline'}
            onClick={() => {
              handleOpenChange(true);
            }}
          >
            <Video />
          </Button>
          <Button
            type={'button'}
            variant={'outline'}
            onClick={() => {
              handleOpenChange(true);
            }}
          >
            <FileUp />
          </Button>
        </div>
      </div>
    </>
  );
}
